import { object } from "../helpers/object";
import { debug } from "../helpers/debug";
import { utils } from "../helpers/utils";
import { responsive } from "../helpers/responsive";
import { mask } from "./mask";

/*------------------------------------*\
  #TOOLTIP

  Gestion de fake tooltip pour des raison SEO

  [data-js-trigger="tooltip"]
\*------------------------------------*/
class Tooltip {


  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT
    document.addEventListener('click', this.clickHandler);
    // DEFAULT EVENT KEYUP
    document.addEventListener('keyup', this.keyHandler);
    // POSITION CHECK on hover/focus (capture phase for mouseenter)
    document.addEventListener('mouseenter', this.positionHandler, true);
    document.addEventListener('focusin', this.positionHandler);

    if(debug.DEBUG) console.log('components/tooltip.js');
  };
  reload = () => {
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
    this.init();
  }

  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    if (event.target.matches('[data-js-trigger="tooltip"]')) {
      if (!responsive.is('md')) {
        mask.display = true;
      }
      if (event.target.matches('[aria-pressed="false"]')) {
        const tooltipEl = event.target.closest('.c-tooltip');
        if (tooltipEl) this.positionTooltip(tooltipEl);
        event.target.setAttribute('aria-pressed', true);
      }
    } else {
      this.closeAll();
    }
  }
  /**
   * POSITION HANDLER
   *
   * Checks tooltip overflow on hover/focus and flips direction if needed
   * @param {event} event
   */
  positionHandler = (event) => {
    const button = event.target.closest('.c-tooltip__button');
    if (!button) return;
    const tooltipEl = button.closest('.c-tooltip');
    if (!tooltipEl) return;
    this.positionTooltip(tooltipEl);
  }
  /**
   * POSITION TOOLTIP
   *
   * Flips to .c-tooltip--top if not enough space below
   * @param {HTMLElement} tooltipEl
   */
  positionTooltip = (tooltipEl) => {
    tooltipEl.classList.remove('c-tooltip--top');
    const content = tooltipEl.querySelector('[role="tooltip"]');
    if (!content) return;
    const rect = tooltipEl.getBoundingClientRect();
    const contentHeight = content.offsetHeight || 80;
    const spaceBelow = window.innerHeight - rect.bottom;
    if (spaceBelow < contentHeight + 10) {
      tooltipEl.classList.add('c-tooltip--top');
    }
  }
  /**
   * CLOSE ON ESC KEY
   * 
   * Fermeture des sub-nav au clic sur la touche echap
   * @param {event} event 
   */
  keyHandler = (event) => {
    if (utils.isEscapKey(event.key || event.keyCode)) {
      this.closeAll();
    } 
  }
  /**
   * CLOSE ALL
   */
  closeAll = () => {
    this.DOM_MODULE
      .filter(element => element.matches('[aria-pressed="true"]'))
      .forEach(element => element.setAttribute('aria-pressed', false));
  }
  
  /**
   * ADD
   * 
   * Create dynamically tooltip
   */
  add = (element, content, classes = []) => {
    element.classList.add('c-tooltip', ...classes);
    
    const tooltipContent = document.createElement('div');
    tooltipContent.classList.add('c-tooltip__content');
    tooltipContent.setAttribute('role', 'tooltip');
    tooltipContent.innerHTML = content;
    
    element.appendChild(tooltipContent);
  };
  /**
   * REMOVE
   * 
   * Remove dynamically tooltip
   */
  remove = (element) => {
    const prefix = "c-tooltip";
    const classes = element.className.split(" ").filter(c => !c.startsWith(prefix));
    element.className = classes.join(" ").trim();
    const tooltipContent = element.querySelector('.c-tooltip__content');
    if (!tooltipContent) return;
    tooltipContent.remove();
  }
}
export const tooltip = new Tooltip('[data-js-trigger="tooltip"]'); 